import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function TimeLeftIndicator({ timeLeft, isMobileView = true }) {
  const [isVisible, setIsVisible] = useState(true);
  const isDesktop = useMediaQuery({ query: "(min-width: 1600px)" });

  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setIsVisible((prev) => !prev);
    }, 1000);

    return () => clearInterval(blinkInterval);
  }, []);

  return (
    <span
      className={`${
        isDesktop ? "font-18px" : "font-16px"
      } valign-wrapper gap-10px ${isVisible ? "red-text" : ""}`}
    >
      {isVisible && isMobileView && (
        <div
          className="red circle"
          style={{ width: "8px", height: "8px" }}
        ></div>
      )}
      <span>Ends in {timeLeft}</span>
    </span>
  );
}

export default TimeLeftIndicator;
